import React, {memo} from "react";
import styled from "styled-components";

export const InputDivWithComment = memo((props) => {
    const {
        type,
        name,
        maxLength,
        focusEvent,
        blurEvent,
        onChange,
        inputState,
        placeholder,
        errorText,
        clickEvent,
        iconEye
    } = props;

    const statusBorderColor = (inputState) => {
        if(inputState == "E") return "RED";
        if(inputState == "G") return "GREEN";
        if(inputState == "PE ") return "#6200EE";
        if(inputState == "PRE ") return "#6200EE";
        
        return "#d0d0d0";
    }
    
    return (
        // <div style={{padding:'8px 0px'}}>
        <div>
            {/* <DivComment /> */}
            <InputDataForm borderColor = {statusBorderColor(inputState)} style={{paddingRight: props.name === "ID" ? "0" : "15px"}}>
                <div style={{ display: "flex", height: "100%"}}>
                    <InputInvisible
                        type={type}
                        name={name}
                        placeholder={placeholder}
                        onFocus={() => focusEvent("A")}
                        onBlur={(e) => blurEvent("I", e.target.value)}
                        onChange={(e) => onChange ? onChange("I", e.target.value) : ""}
                        maxLength={maxLength ? maxLength : ""}
                    />

                    {props.name === "ID" && (
                        <CheckDupId onClick={() => clickEvent()}>
                            중복체크
                        </CheckDupId>
                    )}

                    {iconEye && <img src={iconEye} style={{width:"4vw", display:"block", margin:"auto"}} onClick={()=>{clickEvent ? clickEvent() : ""}} />}
                </div>
            </InputDataForm>
            <InputState status={inputState} errorText={errorText} />
        </div>
    );
})

const DivComment = (props) => {
    return (
        <div
            style={{
                position: "absolute",
                background: "#fff",
                marginLeft: "15px",
                marginTop: "-8px",
            }}
        >
            이름| 한글로 입력하세요
        </div>
    );
};

export const InputState = (props) => {
    const { status, errorText, padding } = props;

    const fontColorByStatus = (status) => {
        if(status === "E") return "RED";
        if(status === "G") return "GREEN";
        return "#d0d0d0";
    }

    return (
        <div
            style={{
                padding: padding ? padding : "4px 0px 10px 12px",
                textAlign: "left",
                color: fontColorByStatus(status),
                fontSize: "12px",
                fontWeight: "600"
            }}
        >
            {status === "E" && <p>{errorText}</p> }
            {status === "G" && <p>{errorText}</p> }
        </div>
    );
};

const InputDataForm = styled.div`
    border: 1px solid ${(props) => props.borderColor};
    border-radius: 8px;
    padding: 0px 15px;
    height: 48px;
`;

const InputInvisible = styled.input`
    border: 0px;
    width: 100%;
    height: 100%;
`;

const CheckDupId = styled.div`
    margin-left: auto;
    background-color: #6200ee;
    border-radius: 12px;
    color: #fff;
    width: 25%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    margin: 4px;
    padding: 0px 8px;
`;
